import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { MAX_VISIBLE_BUTTONS_DESKTOP, MAX_VISIBLE_BUTTONS_MOBILE } from '../../constants/pagination';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import UsageTracker from '../../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const MyTeamTablePagination = ({
  totalResults,
  page,
  pageSize,
  onPageChange
}) => {
  const {
    isNotTablet
  } = useMediaQuery();
  const handlePageChange = event => {
    const newPage = event.target.value;
    if (newPage !== page) {
      UsageTracker.track('teamInteraction', {
        action: 'change-table-page',
        value: newPage
      });
      onPageChange(newPage);
    }
  };
  return /*#__PURE__*/_jsx(Paginator, {
    maxVisiblePageButtons: isNotTablet ? MAX_VISIBLE_BUTTONS_DESKTOP : MAX_VISIBLE_BUTTONS_MOBILE,
    onPageChange: handlePageChange,
    page: page,
    pageCount: Math.ceil(totalResults / pageSize),
    showFirstLastButtons: true
  });
};
export default MyTeamTablePagination;